import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { PromotionPageLayout } from '@/components/layout/PromotionPageLayout';
import { SuccessHero } from './components/SuccessHero';
import { ContactPreview } from './components/ContactPreview';
import { InstructorContact } from './components/InstructorContact';
import { ROUTES } from '@/constants/routes';

export default function PromotionConfirmation() {
  const navigate = useNavigate();
  const location = useLocation();
  const incoming = location.state ?? {};

  useEffect(() => {
    if (!incoming.contact) {
      navigate(ROUTES.promotion, { replace: true });
    }
  }, [incoming.contact, navigate]);

  useEffect(() => {
    if (!incoming.contact) return;
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'conversion', { send_to: 'AW-18170112157/Y2qDCPiF7q4cEJ3Rl9hD' });
  }, [incoming.contact]);

  if (!incoming.contact) return null;

  const firstName = incoming.contact.name.trim().split(' ')[0];

  return (
    <PromotionPageLayout modal modalSize="md">
      <div className="px-6 py-10 text-center sm:px-10 sm:py-14">
        <SuccessHero firstName={firstName} />
        <ContactPreview contact={incoming.contact} editState={incoming} />
        <InstructorContact />
        <p className="mx-auto mt-8 max-w-sm text-xs text-slate-500">
          Remember: the first 2 weeks are free. You only pay once you&apos;re
          convinced.
        </p>
      </div>
    </PromotionPageLayout>
  );
}